// extracted by mini-css-extract-plugin
export default {"spin":"PrioritisationMenu_spin__T2dhX","saveDataInfo":"PrioritisationMenu_saveDataInfo__bFMGk"};